import { ItemTypeConsts, StoreModelMap, StoreModuleMap } from 'client/util/Constants';

const deviceGroupsProvide = {
  groupType: ItemTypeConsts.systemGroup,
  groupModelName: StoreModelMap[ItemTypeConsts.systemGroup],
  itemType: ItemTypeConsts.device,
  itemCollectionName: StoreModuleMap[ItemTypeConsts.device],
  itemLabel: 'Device',
  itemLabelLowerCase: 'device',
  itemLabelPlural: 'Devices',
  itemLabelPluralLowerCase: 'devices',
  itemNameField: 'displayName',
  getBoundItemsUrl: (groupId) => `/api/v2/systemgroups/${groupId}/membership`,
  groupsListRoute: '/groups/device',
  reviewCollectionName: StoreModuleMap[ItemTypeConsts.dgSystemsReview],
  previewCollectionName: StoreModuleMap[ItemTypeConsts.dgSystemsPreview],
  reviewType: ItemTypeConsts.dgSystemsReview,
};

const userGroupsProvide = {
  groupType: ItemTypeConsts.userGroup,
  groupModelName: StoreModelMap[ItemTypeConsts.userGroup],
  itemType: ItemTypeConsts.systemUser,
  itemCollectionName: StoreModuleMap[ItemTypeConsts.systemUser],
  itemLabel: 'User',
  itemLabelLowerCase: 'user',
  itemLabelPlural: 'Users',
  itemLabelPluralLowerCase: 'users',
  itemNameField: 'username',
  getBoundItemsUrl: (groupId) => `/api/v2/usergroups/${groupId}/membership`,
  groupsListRoute: '/groups/user',
  reviewCollectionName: StoreModuleMap[ItemTypeConsts.dgUsersReview],
  previewCollectionName: StoreModuleMap[ItemTypeConsts.dgSystemUsersPreview],
  reviewType: ItemTypeConsts.dgUsersReview,
};

/**
 * A map of values to be used in a provide block of a parent component which integrates with
 * dynamic groups. The key is the `itemType` for a given page -
 * (system / system_group / user / user_group).
 */
export default {
  [ItemTypeConsts.device]: deviceGroupsProvide,
  [ItemTypeConsts.deviceGroup]: deviceGroupsProvide,
  [ItemTypeConsts.system]: deviceGroupsProvide,
  [ItemTypeConsts.systemGroup]: deviceGroupsProvide,
  [ItemTypeConsts.systemUser]: userGroupsProvide,
  [ItemTypeConsts.userGroup]: userGroupsProvide,
};
